import styled from 'styled-components'

const Overlay = styled.div`
  opacity: 0.3;
  background-color: #000;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1;
`

export default Overlay
